import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
    fetchOrgUnitHierarchyReducer,
    selectOrgUnitReducer,
    orgUnitParentReducer,
    fetchOrgUnitsReducer,
    orgUnitTypeReducer,
    fetchOrgUnitTypesReducer,
    orgUnitStaffReducer,
    orgUnitContactReducer
} from './../reduxFiles/reducers';
import placeReducer from './placeReducer';

const initialState = {
    data: {},
    ui: {
        orgUnitsView: {}
    },
    placeLKPS: {},
};

function reducer(state = initialState, action) {
    console.log(action);
    return {
        data: {
            orgUnitHierarchy: fetchOrgUnitHierarchyReducer(state.data.orgUnitHierarchy, action),
            orgUnits: fetchOrgUnitsReducer(state.data.orgUnits, action),
            orgUnitTypes: fetchOrgUnitTypesReducer(state.data.orgUnitTypes, action)
        },
        ui: {
            orgUnitsView: {
                selectedOrgUnit: selectOrgUnitReducer(state.ui.orgUnitsView.selectedOrgUnit, action),
                parentView: orgUnitParentReducer(state.ui.orgUnitsView.parentView, action),
                typeView: orgUnitTypeReducer(state.ui.orgUnitsView.typeView, action),
                staffView: orgUnitStaffReducer(state.ui.orgUnitsView.staffView, action),
                contactView: orgUnitContactReducer(state.ui.orgUnitsView.contactView, action)
            }
        },
        placeLKPS: placeReducer(state.placeLKPS, action)
    };
}

export default createStore(
    reducer,
    composeWithDevTools(applyMiddleware(thunkMiddleware // lets us dispatch() functions
    ))
);



// WEBPACK FOOTER //
// ./src/reduxFiles/store.js